export const LANDING_TYPE = {
    generic: 'generic',
    flats: 'flats',
    commercial: 'commercial',
    plots: 'plots',
    houses: 'houses',
};
export const PAGE_CONFIGURATION = {
    fsrbo: 'fsrbo',
    frbo: 'frbo',
    fsbo: 'fsbo',
};
